import React, { useContext } from "react";
import {
  Drawer as MaterialDrawer,
  Grid,
  makeStyles,
  List,
  Divider,
  Box,
  Avatar,
  Typography,
  useTheme,
  useMediaQuery,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import clsx from "clsx";
import { AuthContext, SelectedLabContext } from "../context";
import {
  DoctorsIcon,
  DoctorsApprovalIcon,
  ActiveDoctorsIcon,
  LaboratoriesIcon,
  ProductsApprovalIcon,
  UsersIcon,
  OperatorsIcon,
  LogsIcon,
  ReportsIcon,
  ExitIcon,
  CategoriesIcon,
  ProductsIcon,
  SampleAssignmentIcon,
  SampleTrackingIcon,
  OrderApprovalIcon,
  BussinesUnitIcon,
  PatientRepetitionRateIcon,
  SamplesToRunOutIcon,
  SamplesAvailableIcon,
  TopIcon,
  AssignmentstIcon,
  HistoryIcon,
} from "../icons";
import { NavItem, Logo } from "./";
import {
  AdjustRounded,
  GavelOutlined,
  HealingRounded,
  LocalLibraryRounded,
  WorkRounded,
} from "@material-ui/icons";

const items = [
  {
    href: "/",
    icon: DoctorsIcon,
    title: "Médicos",
    roles: ["MASTER", "USER_LABORATORY", "LABORATORY_ADMIN", "ADMINISTRADOR"],
  },
  {
    // href: "/operator-assignments",
    href: "/",
    icon: AssignmentstIcon,
    title: "Asignaciones",
    roles: ["OPERADOR", "CHILD_OPERATOR"],
  },
  {
    href: "/assignments-wrong-address",
    icon: AssignmentstIcon,
    title: "Asignaciones (direccion errónea)",
    roles: ["OPERADOR", "CHILD_OPERATOR"],
  },
  {
    href: "/history",
    icon: HistoryIcon,
    title: "Historial",
    roles: ["OPERADOR", "CHILD_OPERATOR"],
  },
  {
    href: "/doctors-approval",
    icon: DoctorsApprovalIcon,
    title: "Aprobar medicos",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: "/active-doctors",
    icon: ActiveDoctorsIcon,
    title: "Medicos activos",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: "/laboratories",
    icon: LaboratoriesIcon,
    title: "Laboratorios",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: "/categories",
    icon: CategoriesIcon,
    title: "Categorías",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/products",
    icon: ProductsIcon,
    title: "Productos",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/products-approval",
    icon: ProductsApprovalIcon,
    title: "Aprobar productos",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: "/products-avaible",
    icon: ProductsIcon,
    title: "Productos disponibles",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  // {
  //   href: "/assignments",
  //   icon: SampleAssignmentIcon,
  //   title: "Asignación de muestras",
  //   roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  // },
  {
    href: "/assign-to-doctors",
    icon: SampleAssignmentIcon,
    title: "Asignación de muestras",
    roles: ["MASTER", "USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/assign-to-representative",
    icon: SampleAssignmentIcon,
    title: "Asignación a representantes",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/assign-to-operator",
    icon: SampleTrackingIcon,
    title: "Seguimiento de entregas",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  /*{
    href: "/assigned-operators",
    icon: UserIcon,
    title: "Seguimiento de entrega de muestras médicas",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },*/
  {
    href: "/orders",
    icon: OrderApprovalIcon,
    title: "Aprobar ordenes",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/users",
    icon: UsersIcon,
    title: "Usuarios",
    roles: ["MASTER", "LABORATORY_ADMIN", "USER_LABORATORY"],
  },
  {
    href: "/assignments-to-patients",
    icon: UsersIcon,
    title: "Asignaciones a Pacientes",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: "/business-units",
    icon: BussinesUnitIcon,
    title: "Unidad de negocios",
    roles: ["LABORATORY_ADMIN"],
  },
  {
    href: "/operators",
    icon: OperatorsIcon,
    title: "Operadores",
    roles: ["MASTER", "ADMINISTRADOR"],
  },
  {
    href: null,
    icon: LogsIcon,
    title: "Logs",
    roles: ["MASTER", "ADMINISTRADOR"],
    collapse: true,
    options: [
      {
        icon: TopIcon,
        href: "/doctor-assignments-top",
        title: "Top asignaciones a medicos",
      },
      {
        icon: TopIcon,
        href: "/most-requested-products",
        title: "Top productos mas solicitados",
      },
    ],
  },
  {
    href: "/reports",
    icon: ReportsIcon,
    title: "Reportes",
    roles: ["USER_LABORATORY", "ADMINISTRADOR", "MASTER"],
  },
  {
    href: "/patients-repetition-rate",
    icon: PatientRepetitionRateIcon,
    title: "Índice de repetición de pacientes",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: "/samples-to-run-out",
    icon: SamplesToRunOutIcon,
    title: "Muestras por agotarse",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: null,
    icon: LocalLibraryRounded,
    title: "Zonas de visita",
    roles: ["LABORATORY_ADMIN"],
    collapse: true,
    options: [
      {
        icon: AdjustRounded,
        href: "/zones",
        title: "Zonas",
      },
      {
        icon: HealingRounded,
        href: "/zones/doctors",
        title: "Médicos",
      },
      {
        icon: WorkRounded,
        href: "/zones/representative",
        title: "Representantes",
      },
    ],
  },
  {
    href: null,
    icon: LocalLibraryRounded,
    title: "Relleno automático",
    roles: ["LABORATORY_ADMIN"],
    collapse: true,
    options: [
      {
        icon: AdjustRounded,
        href: "/refill",
        title: "Categorías",
      },
      {
        icon: HealingRounded,
        href: "/refill/doctors",
        title: "Médicos",
      },
      // {
      //   icon: WorkRounded,
      //   href: "/refill/products",
      //   title: "Productos",
      // },
    ],
  },
  {
    href: "/consent",
    icon: GavelOutlined,
    title: "Consentimiento informado",
    roles: ["MASTER", "LABORATORY_ADMIN"],
  },
  {
    href: "/samples-available",
    icon: SamplesAvailableIcon,
    title: "Muestras disponibles",
    roles: ["USER_LABORATORY", "LABORATORY_ADMIN"],
  },
  {
    href: null,
    icon: ExitIcon,
    title: "Salir",
    roles: [
      "USER_LABORATORY",
      "LABORATORY_ADMIN",
      "MASTER",
      "ADMINISTRADOR",
      "OPERADOR",
      "CHILD_OPERATOR",
    ],
  },
];

export default function Drawer(props) {
  const matches = useMediaQuery(useTheme().breakpoints.up("md"));
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const { selectedLab, setSelectedLab } = useContext(SelectedLabContext);
  const { open, setOpen } = props;

  const isOperator = authState.user?.role.name === "OPERADOR" || authState.user?.role.name === "CHILD_OPERATOR";
  const operatorLabs = authState.user?.operator?.laboratoriesData || [];

  return (
    <MaterialDrawer
      variant={matches ? "permanent" : "temporary"}
      open={/*matches? true : drawerState.*/ open}
      onClose={() => /*setDrawer()*/ setOpen(false)}
      classes={{
        docked: classes.docked,
        paper: clsx(
          classes.drawerPaper,
          !(/*drawerState.*/ open) && classes.drawerPaperClose
        ),
      }}
    >
      <Box
        alignItems="center"
        display="flex"
        justifyContent={"center"}
        p={2}
        pb={1}
      >
        <Logo />
      </Box>
      <Box alignItems="center" display="flex" p={2} pt={1}>
        <Grid container>
          <Grid item sm={3}>
            <Avatar className={classes.avatar} src={""} />
          </Grid>
          <Grid item sm={9}>
            <Typography
              className={classes.name}
              color="textPrimary"
              variant="h5"
            >
              {authState.user?.role.name === "LABORATORY_ADMIN" ||
              authState.user?.role.name === "USER_LABORATORY"
                ? authState.user?.laboratory.name.toUpperCase()
                : authState.user?.username.toUpperCase()}
            </Typography>
            <Typography
              className={classes.roleName}
              color="textSecondary"
              variant="body2"
            >
              {authState.user?.role.name}
            </Typography>
            {isOperator && operatorLabs.length > 0 && (
              <FormControl fullWidth size="small" className={classes.labSelector}>
                <Select
                  value={selectedLab ? selectedLab._id : ""}
                  onChange={(e) => {
                    const found = operatorLabs.find((l) => l._id === e.target.value);
                    setSelectedLab(found || null);
                  }}
                  displayEmpty
                >
                  <MenuItem value="">Todos los laboratorios</MenuItem>
                  {operatorLabs.map((lab) => (
                    <MenuItem key={lab._id} value={lab._id}>
                      {lab.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <List>
        {items.map((item, index) =>
          item.roles.find((rol) => rol === authState.user?.role.name) ? (
            <React.Fragment key={index}>
              <NavItem
                href={item.href}
                key={item.title}
                title={item.title}
                icon={item.icon}
                collapse={item.collapse}
                options={item.options}
              />
            </React.Fragment>
          ) : null
        )}
      </List>
    </MaterialDrawer>
  );
}

const useStyles = makeStyles((theme) => ({
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  avatar: {
    // backgroundColor: theme.palette.secondary.main,
    backgroundColor: theme.palette.grey[500],
  },
  name: {
    fontSize: "1.125rem",
    // color: theme.palette.primary.main,
    // fontWeight: "600",
  },
  roleName: {
    // color: theme.palette.secondary.main,
  },
  labSelector: {
    marginTop: theme.spacing(1),
    "& .MuiSelect-root": {
      fontSize: "0.75rem",
      paddingTop: 6,
      paddingBottom: 6,
    },
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    height: "100vh",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.only("sm")]: {
      width: "40%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "70%",
    },
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  docked: {
    // width: "25%",
    flex: `0 1 25%`,
    maxWidth: 280,
  },
}));
